cv.InviteView = Marionette.LayoutView.extend({
  template: cv.Templates['auth/invite'],

  events : {
    'click .auth-close' : 'authClose',
    'click .login' : 'login',
    'keyup input' : 'loginOnEnter'
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior
  }],

  validation: {
    invite_code: [{
        required: 'true',
        msg: "Required"
    }]
  },

  templateHelpers: function(){
    return {
      heading : this.options.heading,
      description : this.options.description
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    // Determine if we are in a window or not
    if(window.name != 'auth'){
      this.in_iframe = false;
    }else{
      this.in_iframe = true;
    }

    // Set a default
    if(_.isUndefined(this.options.team_id)){
      this.options.team_id = null;
    }

    // Login trigger
    this.listenTo(this, 'form:saved', function(){
      $.ajax({
        url: cv.api_path + '/auth/login',
        dataType: "json",
        data: {
          login : this.model.get('login'),
          password : this.model.get('password'),
          invite_code : this.model.get('invite_code'),
          campaign_id : cv.campaign.get('id'),
          team_id : this.options.team_id
        },
        type: "post",
        success: _.bind(function(data){
          if(data.project_stub != ''){
            top.location = '/' + data.project_stub + '/admin/dashboard';
          }else{
            top.location = '/fundraiser_setup';
          }
        }, this),
        error: _.bind(function(data){
          Backbone.Validation.error(this, 'invite_code', 'Invalid Code');
          vent.trigger('notif:error', 'Please enter a valid invite code.');
        }, this)
      });
    }, this);

    this.listenTo(this, 'form:changed', function(model){
    }, this);

    this.listenTo(this, 'form:has_errors', function(){
      vent.trigger('notif:error', 'Please fix the errors on this form.');
    }, this);

    console.log('InviteView initialized.');
  },

  authClose: function(e){
    e.preventDefault();

    // Close the items
    $('body').addClass('hidden');
    setTimeout(_.bind(function(){
      window.top.postMessage("close-auth", "*");
    }, this), 250);
  },

  loginOnEnter: function(e) {
    e.preventDefault();

    // If we don't hit enter, then do nothing
    if (e.keyCode != 13) return;

    this.$('#invite_code').change();

    this.login(e);
  },

  login: function(e){
    e.preventDefault();
    e.stopPropagation();

    this.trigger('form:save');
  },

  onShow: function(){
    // Change document title
    document.title = 'Invite Code';
  }
});
